import { type StateCode } from "../_internals/constants/states";

export const UF_TO_VOTER_ID_CODE: Record<StateCode | "ZZ", string> = {
	SP: "01",
	MG: "02",
	RJ: "03",
	RS: "04",
	BA: "05",
	PR: "06",
	CE: "07",
	PE: "08",
	SC: "09",
	GO: "10",
	MA: "11",
	PB: "12",
	PA: "13",
	ES: "14",
	PI: "15",
	RN: "16",
	AL: "17",
	MT: "18",
	MS: "19",
	DF: "20",
	SE: "21",
	AM: "22",
	RO: "23",
	AC: "24",
	AP: "25",
	RR: "26",
	TO: "27",
	ZZ: "28",
};
